import { Dialog, Stack, Typography, Button } from '@mui/material';
import { Spin } from 'antd';
import React from 'react';

export function ConfirmationDialog({
	open,
	onClose,
	onConfirm,
	loading,
	title,
	subTitle,
	cancelText = 'Cancel',
	confirmText = 'Confirm',
	zIndex = 1500,
}) {
	return (
		<Dialog open={open} onClose={onClose} sx={{ zIndex }}>
			<Stack p={2} minWidth={400}>
				<Typography variant="body1">{title}</Typography>
				<Typography variant="subtitle2" component="div" dangerouslySetInnerHTML={{ __html: subTitle }} />
				<Stack mt={3} direction="row" gap={2} justifyContent="flex-end">
					<Button size="medium" color="info" variant="outlined" onClick={onClose} disabled={loading}>
						{cancelText}
					</Button>
					<Button size="medium" color="info" variant="contained" onClick={onConfirm} disabled={loading}>
						{loading ? <Spin /> : confirmText}
					</Button>
				</Stack>
			</Stack>
		</Dialog>
	);
}
